import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import app from '../app/store/app';
import eps from '../pages/prizes/store/eps';
import payments from '../pages/prizes/store/payments';
import banners from '../pages/profile/store/banners';
import bonuses from '../pages/profile/store/bonuses';
import surveys from '../pages/profile/store/surveys';
import webpush from '../pages/profile/store/webpush';
import courses from '../pages/courses/store/courses';
import notifications from '../pages/profile/store/notifications';
import mobileNotifications from '../pages/mobileNotifications/store/mobileNotifications';
import sales from '../pages/sales/store/sales';
import news from '../pages/news/store/news';
import tickets from '../pages/tickets/store/tickets';
import shop from '../pages/shop/store/shop';
import portfolio from '../pages/portfolio/store/portfolio';
import seminars from '../pages/seminars/store/seminars';
import specializations from '../pages/specializations/store/specializations';
import jobs from '../pages/jobs/store/jobs';
import game from '../pages/game/store/game';
import design from '../pages/design/store/design';


// eslint-disable-next-line import/no-cycle
import { ax, axf, axl } from '../customAxios';
import applications from '../pages/application/store/applications';
import chat from '../pages/chat/store/chat';
import guarantees from '../pages/guarantees/store/guarantees';

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [createPersistedState({ key: 'promo', ssr: false })],
  state: {
    loading: false,
    submenu: '',
    dialogs: {
      surveys: true,
      notifications: true,
    },
    profile_id: null,
    token: null,
    user: null,
    profileLoaded: false,
    userTransactions: [],
    userStatusTransactions: [],
    purses: [],
    paymentsInfo: {},
    paymentsConfig: {},
    paymentOperators: {},
    paymentBanks: {},
    counters: {},
    settings: {
      register_rules: true,
      register_pers: true,
    },
    lastRoute: '/dashboard',
    pageTitle: '',
  },
  mutations: {
    setLastRoute(state, route) {
      state.lastRoute = route;
    },
    menuSide(state, settings) {
      state.settings.layout = settings;
    },
    SetSubmenu(state, payload) {
      state.submenu = payload;
    },
    SetSettings(state, settings) {
      state.settings = settings;
    },
    SetUser(state, payload) {
      state.user = payload;
    },
    SetPurses(state, payload) {
      state.purses = payload;
    },
    SetDialog(state, payload) {
      state.dialogs[payload.dialog] = payload.value;
    },
    SetUserTransactions(state, payload) {
      state.userTransactions = payload;
    },
    SetUserStatusTransactions(state, payload) {
      state.userStatusTransactions = payload;
    },
    SetLogged(state, payload) {
      state.profile_id = payload.profile_id;
      state.token = payload.token;
    },
    SetTitleMutation(state, payload) {
      state.pageTitle = payload;
    },
    SetLoading(state, payload) {
      state.loading = payload;
    },
    SetPaymentsConfig(state, payload) {
      state.paymentsConfig = payload;
    },
    SetPaymentsSettings(state, payload) {
      state.paymentsInfo = payload;
    },
    SetPaymentOperators(state, payload) {
      state.paymentOperators = payload;
    },
    SetPaymentBanks(state, payload) {
      state.paymentBanks = payload;
    },
    SetCounters(state, payload) {
      state.counters = payload;
    },
    InitialStore(state) {
      state.loading = false;
      state.submenu = '';
      state.dialogs = {
        surveys: true,
        notifications: true,
      };
      state.profile_id = null;
      state.token = null;
      state.user = null;
      state.userTransactions = [];
      state.userStatusTransactions = [];
      state.paymentsInfo = {};
      state.counters = {};
      state.settings = {};
    },
    Logout(state) {
      state.profile_id = null;
      state.user = null;
      state.token = null;
    },
  },
  actions: {
    SetTitle({ commit }, payload) {
      commit('SetTitleMutation', payload);
    },
    SetSubmenu({ commit }, payload) {
      commit('SetSubmenu', payload);
    },
    SetLoading({ commit }, payload) {
      commit('SetLoading', payload);
    },
    UnsetError() {
      Vue.notify({ group: 'error', clean: true });
    },
    UnsetInfo() {
      Vue.notify({ group: 'info', clean: true });
    },
    ShowInfo({ dispatch }, message) {
      dispatch('UnsetError');
      dispatch('UnsetInfo');
      dispatch('ShowInfoMessage', message);
    },
    ShowError({ dispatch }, message) {
      dispatch('UnsetError');
      dispatch('UnsetInfo');
      dispatch('ShowErrorMessage', message);
    },
    ShowErrorMessage({}, message) {
      const text = message;
      Vue.notify({ group: 'error', type: 'error', text, duration: 60000 });
    },
    ShowInfoMessage({}, message) {
      const text = message;
      Vue.notify({ group: 'info', type: 'info', text, duration: 7000 });
    },
    HandleError({ dispatch }, error) {
      if (error.response) {
        // Error recieved from the server
        const { data } = error.response;
        let errors = [];
        if ('error' in data) {
          errors = [data.error];
        } else if ('errors' in data) {
          if (Array.isArray(data.errors)) {
            ({ errors } = data);
          } else {
            Object.keys(data.errors).forEach((k) => {
              errors.push(data.errors[k]);
            });
          }
        }
        // maximum show 2 errors
        if (errors.length > 2) {
          errors = errors.slice(0, 2);
        }
        errors.forEach((message) => {
          dispatch('ShowErrorMessage', message);
        });
      } else if (error.request) {
        // The request was made but no response was received
        dispatch('ShowErrorMessage', 'С вашим подключением не все так просто. Пожалуйста, проверьте доступ к интернету');
      } else {
        // Something happened in setting up the request that triggered an Error
        dispatch('ShowErrorMessage', 'Что-то пошло не так');
        console.log(error.config);
      }
    },
    GetSettings({ commit, getters }) {
      return new Promise((resolve, reject) => {
        getters.ax.post('api/settings')
          .then((response) => {
            if (response && response.data) {
              commit('SetSettings', response.data.settings);
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch(error => reject(error));
      });
    },
    GetCounters({ commit, getters }) {
      return new Promise((resolve, reject) => {
        getters.ax.post('profiles/api/counters/list')
          .then((response) => {
            if (response && response.data) {
              commit('SetCounters', response.data.counters);
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch(error => reject(error));
      });
    },
    GetProfile({ commit, state, getters, dispatch }) {
      return new Promise((resolve, reject) => {
        if (state.profile_id) {
          getters.ax.post('profiles/api/auth/get-profile', { profile_id: state.profile_id })
            .then((response) => {
              if (response && response.data) {
                commit('SetUser', response.data.profile);
                commit('SetPurses', response.data.profile.purses.filter(item => item.balance > 0));
                resolve(response.data);
                state.profile_loaded = true;
              }
              reject(new Error('no response data'));
            })
            .catch((error) => {
              if (error.response.status === 401) {
                dispatch('UserLogout');
                this.router.push('/');
              }
              reject(error);
            });
        } else {
          resolve(null);
        }
      });
    },
    GetTransactions({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        if (state.profile_id) {
          getters.axl.post('profiles/api/transaction/list', { profile_id: state.profile_id })
            .then((response) => {
              if (response && response.data) {
                commit('SetUserTransactions', response.data.transactions);
                resolve(response.data);
              }
              reject(new Error('no response data'));
            })
            .catch(error => reject(error));
        }
      });
    },
    GetStatusTransactions({ commit, state, getters }) {
      return new Promise((resolve, reject) => {
        if (state.profile_id) {
          getters.axl.post('profiles/api/status-transaction/list', { profile_id: state.profile_id })
            .then((response) => {
              if (response && response.data) {
                commit('SetUserStatusTransactions', response.data.transactions);
                resolve(response.data);
              }
              reject(new Error('no response data'));
            })
            .catch(error => reject(error));
        }
      });
    },
    GetPaymentsSettings({ commit, state, getters }) {
      if (state.profile_id) {
        getters.ax.post('payments/api-v4/forms/config', { profile_id: state.profile_id })
          .then((configResponse) => {
            const { config } = configResponse.data;
            commit('SetPaymentsConfig', config);
            if (config.card_bank) {
              getters.ax.post('payments/api-v4/forms/operators', { profile_id: state.profile_id })
                .then((operatorsResponse) => {
                  commit('SetPaymentOperators', operatorsResponse.data.operators);
                });
            }
            if (config.phone_operator) {
              getters.ax.post('payments/api-v4/forms/banks', { profile_id: state.profile_id })
                .then((operatorsResponse) => {
                  commit('SetPaymentBanks', operatorsResponse.data.banks);
                });
            }
          });
        getters.ax.post('payments/api-v4/forms/types', { profile_id: state.profile_id })
          .then((typesResponse) => {
            commit('SetPaymentsSettings', typesResponse.data.types);
          });
      }
    },
    UserLogin({ commit, dispatch }, payload) {
      commit('SetLogged', payload);
      dispatch('app/SetSidebar', true);
      dispatch('ShowInfoMessage', 'Добро пожаловать!');
    },
    UserLogout({ commit, dispatch }) {
      commit('Logout');
      commit('InitialStore');
      dispatch('courses/InitialStoreCourses');
      dispatch('mobileNotifications/InitialStoreNotifications');
      dispatch('news/InitialStoreNews');
      dispatch('eps/InitialStoreEps');
      dispatch('payments/InitialStorePayments');
      dispatch('banners/InitialStoreBanners');
      dispatch('bonuses/InitialStoreBonuses');
      dispatch('notifications/InitialStoreNotifications');
      dispatch('surveys/InitialStoreSurveys');
      dispatch('sales/InitialStoreSales');
      dispatch('shop/InitialStateShop');
      dispatch('tickets/InitialStoreTickets');
      dispatch('portfolio/InitialStorePortfolio');
      dispatch('webpush/ResetToken');
      localStorage.clear();
      dispatch('GetSettings');
      dispatch('game/InitialStoreGames');
    },
    DownloadFile({ getters, dispatch }, info) {
      getters.axf.post(info.url, info.data).then((response) => {
        const blob = new Blob([response.data]);
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, info.filename);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', info.filename);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
      }).catch((error) => {
        dispatch('HandleError', error);
      });
    },
  },
  getters: {
    ax(state) {
      const instance = ax(state);
      return instance;
    },
    axl(state) {
      const instance = axl(state);
      return instance;
    },
    axf(state) {
      const instance = axf(state);
      return instance;
    },
    token(state) {
      return state.token;
    },
    isAuthenticated(state) {
      return state.profile_id !== null && state.profile_id !== undefined
        && state.token !== null && state.token !== undefined;
    },
  },
  modules: {
    app,
    courses,
    eps,
    payments,
    surveys,
    notifications,
    mobileNotifications,
    sales,
    news,
    tickets,
    banners,
    bonuses,
    shop,
    webpush,
    portfolio,
    seminars,
    specializations,
    jobs,
    applications,
    chat,
    game,
    guarantees,
    design,
  },
});

export default store;
